/**
 * App Icons - Soft 3D Pastel Icons
 * 
 * Custom generated icons matching modern iOS design with:
 * - Soft pastel colors
 * - Slightly 3D / soft depth
 * - Rounded shapes
 * - Friendly illustrations
 * - Light shadows
 */

export const APP_ICONS = {
  // Main Feature Cards - Transparent background icons
  emergencyBinder: "https://static.prod-images.emergentagent.com/jobs/1a8f8512-5ee0-46d4-a250-4397842b8d6c/images/f2b05628906c2301dc028bbce98ce75c6e22d798eb8307014324e05278ca481d.png",
  documents: "https://static.prod-images.emergentagent.com/jobs/1a8f8512-5ee0-46d4-a250-4397842b8d6c/images/de1d030c888fee446e3369b55e00bf6180c3fa9d8f701fa4f16dd18385a49a28.png",
  parking: "https://static.prod-images.emergentagent.com/jobs/1a8f8512-5ee0-46d4-a250-4397842b8d6c/images/77730e73d1175ebe2821d4d5ee0740d5327c862e14416c568cfa60f32544e663.png",
  dates: "https://static.prod-images.emergentagent.com/jobs/1a8f8512-5ee0-46d4-a250-4397842b8d6c/images/38179509c4c100fdb0bfb52d2ea4c37f59ab126f621da6a97e9c02940a96a149.png",
  carMaintenance: "https://static.prod-images.emergentagent.com/jobs/1a8f8512-5ee0-46d4-a250-4397842b8d6c/images/2281e450b622e07f405ef07982448a163d5c9fccc9dbdd9cb9c76d1885df7e36.png",
  familyContacts: "https://static.prod-images.emergentagent.com/jobs/1a8f8512-5ee0-46d4-a250-4397842b8d6c/images/053eabe759c18340a459980ffdf5ce4d5745bf66813fd4fd6ec95e5841a8557b.png",
  
  // Quick Action Items
  medicalInfo: "https://static.prod-images.emergentagent.com/jobs/90b64214-a213-4d82-865b-94ba98e9a1ca/images/72ac9b66b3bd1fb4b118a8fea6135424830ec7d52905b5a56dd0200df662e8c2.png",
  doctor: "https://static.prod-images.emergentagent.com/jobs/90b64214-a213-4d82-865b-94ba98e9a1ca/images/e50d5f9b461783201fe05a23fea6bd593ee1ff41211fcff434163b4c15d1f0b3.png",
  medication: "https://static.prod-images.emergentagent.com/jobs/90b64214-a213-4d82-865b-94ba98e9a1ca/images/ffac9bb6df391e493e70e4dc3c7810dd44152bc764f284ce9bc2d606a66e18bb.png",
  emergency: "https://static.prod-images.emergentagent.com/jobs/90b64214-a213-4d82-865b-94ba98e9a1ca/images/53239efde4b91f02e5077254326dff72ba0591e0e0c6dd3518ceff898e85d1bc.png",
  pet: "https://static.prod-images.emergentagent.com/jobs/90b64214-a213-4d82-865b-94ba98e9a1ca/images/1b91cee29faba934e720b7291f25e94930b5b37fd229f6b07bcc79489c0fde3a.png",
  notes: "https://static.prod-images.emergentagent.com/jobs/90b64214-a213-4d82-865b-94ba98e9a1ca/images/552e000d180865ad9b7f4567229a0d3ec0f0190a60523ef28787564c93643187.png",
};

/**
 * PastelIcon - Renders a soft 3D pastel icon
 */
export const PastelIcon = ({ src, alt, size = 48, className = "" }) => {
  return (
    <img 
      src={src} 
      alt={alt}
      className={`object-contain ${className}`}
      style={{ 
        width: `${size}px`, 
        height: `${size}px`,
        filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))'
      }}
    />
  );
};

export default APP_ICONS;
